import { AppInfo } from "./AppInfo";
import { generateUUID } from "../utils/Utils";
export class Token {
    constructor(accountId, apps, userEmail) {
        this.comingFromAppId = "Nyx";
        this.accountId = accountId;
        this.appInfoByApp = new Map();
        for (const app of apps) {
            this.appInfoByApp.set(app, new AppInfo());
        }
        this.id = generateUUID();
        this.hasJwt = false;
        this.userEmail = userEmail;
    }
    mapAppInfoByAppToObject() {
        const objectFromMap = Object.create(null);
        for (const [app, appInfo] of this.appInfoByApp.entries()) {
            objectFromMap[app] = appInfo.toObject();
        }
        return objectFromMap;
    }
}
